import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}/Product`;

export const fetchProducts = async (branchId, includeAll = true) => {
  let url = `${API_BASE_URL}`;
  const params = [];
  if (branchId) params.push(`branchId=${branchId}`);
  if (includeAll) params.push(`includeAll=true`);
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  const response = await axios.get(url);
  return response.data;
};

// ✅ FIXED: Correct API URL
export const getSupportedCurrencies = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/currencies`); // ✅ Fixed URL
    return response.data;
  } catch (error) {
    console.error('Error fetching currencies:', error);
    // Return default currencies as fallback
    return {
      Success: true,
      Currencies: [
        { code: 'YER', symbol: 'ر.ي', name: 'ريال يمني قديم', decimals: 0 },
        { code: 'YRN', symbol: 'ر.ي.ج', name: 'ريال يمني جديد', decimals: 0 },
        { code: 'USD', symbol: '$', name: 'دولار أمريكي', decimals: 2 },
        { code: 'SAR', symbol: 'ر.س', name: 'ريال سعودي', decimals: 2 }
      ],
      DefaultCurrency: 'YER'
    };
  }
};

export const fetchProductById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const updateProduct = async (id, productData) => {
  const response = await axios.put(`${API_BASE_URL}/EditProduct/${id}`, productData);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const createProduct = async (productData) => {
  const response = await axios.post(API_BASE_URL, productData);
  return response.data;
};

// ✅ NEW: Update product prices (for offers/grouped products)
export const updateProductPrices = async (productId, pricesData) => {
  const response = await axios.put(
    `${config.API_BASE_URL}/Product/${productId}/prices`,
    pricesData
  );
  return response.data;
};


export const createGroupedProduct = async (groupData) => {
  const response = await axios.post(`${API_BASE_URL}/GroupProductsOffer`, groupData);
  return response.data;
};
